import 'react-datepicker/dist/react-datepicker.css'
import { DateTime } from 'luxon'
import { FullCalendarMonthPicker } from '../../common/datepicker/fullcalendarmonthpicker.jsx'
import { FullCalendarToolbar } from '../../common/fullcalendar/fullcalendartoolbar.jsx'
import i18n from '../../i18n'

export function PersonalCalendarToolbar({ calendarRef }) {
	const calendarApi = calendarRef.getApi()
	const startMonthTitle = DateTime.fromJSDate(calendarApi.currentData?.dateProfile?.currentRange?.start)
		.setLocale(i18n.resolvedLanguage)
		.toFormat('LLLL yyyy')

	const endMonthTitle = DateTime.fromJSDate(calendarApi.currentData?.dateProfile?.currentRange?.start)
		.plus({ month: 1 })
		.setLocale(i18n.resolvedLanguage)
		.toFormat('LLLL yyyy')
	return (
		<FullCalendarToolbar
			calendarRef={calendarRef}
			title={<h3 className="mb-0">{`${startMonthTitle} - ${endMonthTitle}`}</h3>}
			calendarController={
				<FullCalendarMonthPicker calendarRef={calendarRef} title={`${startMonthTitle} - ${endMonthTitle}`} />
			}
		/>
	)
}
